import { useState, useEffect } from 'react';
import { ApiGet } from '../Function';
import { titleColor, backgroundMainColor, backgroundSubColor, gridCellBackgroundColor, gridCellFontColor } from '../Color';
import TopBar from '../TopBar';

export default function CncAnomalyDetection() {
  const dataNames = {
    'SpindleLoad_mean': '스핀들 부하(%) 평균',
    'SpindleLoad_std': '스핀들 부하(%) 표준편차',
    'SpindleLoad_max': '스핀들 부하(%) 최대값',
    'SpindleLoad_p2p': '스핀들 부하(%) 진폭 크기',
    'spindle_load_cv': '스핀들 부하(%) 변동계수',
    'ActS_mean': '스핀들 실제 속도 평균',
    'ActS_std': '스핀들 실제 속도 표준편차',
    'ActF_mean': '이송 속도 평균',
    'ActF_std': '이송 속도 표준편차',
    'ServoError_max': '서보 위치 오차 최대값',
    'ServoError_mean': '서보 위치 오차 평균',
    'ServoCurrent_mean': '서보 모터 전류 평균',
    'ServoCurrent_std': '서보 모터 전류 표준편차',
    'ServoCurrent_max': '서보 모터 전류 최대값',
    'ServoCurrentPer_mean': '서보 전류 대비 정격 비율 평균',
    'ServoCurrentPer_max': '서보 전류 대비 정격 비율 최대값',
    'ServoLoad_mean': '서보 모터 부하(%) 평균',
    'ServoLoad_max': '서보 모터 부하(%) 최대값',
    'SpindleTemp_mean': '스핀들 온도 평균',
    'ServoTemp_mean': '서보 모터 온도 평균',
    'alarm_occurred': '사이클 중 알람 발생 여부'
  };
  const [data, setData] = useState({
    cycleId: 0,
    start: '',
    end: '',
    anomalyScore: 0,
    isAnomaly: 0,
    durationSec: 0,
    durationTime: {
      hours: 0,
      minutes: 0,
      seconds: 0
    },
    features: {}
  });

  useEffect(() => {
    document.title = 'JS MONITORING';


    Inquiry();
    let intervalId = setInterval(() => {
      Inquiry();
    }, 1000 * 60);

    return () => {      
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  async function Inquiry() {
    const response = await ApiGet(`${process.env.REACT_APP_API_DOMAIN}js/cnc/anomaly-detection`);
    if (response !== null && response.ok) setData((await response.json()).data);
  }

  const logoContent = <span style={{ color: titleColor, fontSize: 40, fontWeight: 'bold' }}>JS</span>;

  const rowStyle = { width: '100%', display: 'flex', flexDirection: 'row', gap: 10 };
  const columnStyle = { width: '35%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: backgroundSubColor, color: titleColor, borderRadius: 8 };
  const cellStyle = { width: '65%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: gridCellBackgroundColor, color: gridCellFontColor, borderRadius: 8 };

  return (
    <div style={{ width: '100%', height: '100vh', backgroundColor: backgroundMainColor}}>
      <TopBar logo={logoContent} title={'CNC 이상탐지 모니터링'} />

      <div style={{ width: '100%', height: 'calc(100vh - 60px)', display: 'flex', flexDirection: 'row', gap: 30, backgroundColor: backgroundMainColor, padding: 30, boxSizing: 'border-box', fontSize: 40 }}>
        <div style={{ width: '60%', height: '100%', display: 'flex', flexDirection: 'column', gap: 30 }}>
          <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', gap: 10 }}>
            <div style={{ ...columnStyle, width: '100%', height: '9%' }}>
              작업 정보
            </div>

            <div style={{ ...rowStyle, height: '16%' }}>
              <div style={columnStyle}>
                시작 시간
              </div>

              <div style={cellStyle}>
                {data.start}
              </div>
            </div>

            <div style={{ ...rowStyle, height: '16%' }}>
              <div style={columnStyle}>
                종료 시간
              </div>

              <div style={cellStyle}>
                {data.end}
              </div>
            </div>

            <div style={{ ...rowStyle, height: '16%' }}>
              <div style={columnStyle}>
                소요 시간
              </div>

              <div style={cellStyle}>
                {data.durationTime.hours}시간 {data.durationTime.minutes}분 {data.durationTime.seconds}초
              </div>
            </div>

            <div style={{ height: '2%' }} />

            <div style={{ ...columnStyle, width: '100%', height: '9%' }}>
              결과
            </div>

            <div style={{ ...rowStyle, height: '16%' }}>
              <div style={columnStyle}>
                판정
              </div>

              <div style={{ ...cellStyle, color: data.isAnomaly ? 'red' : titleColor }}>
                {data.isAnomaly ? 'X' : 'O'}
              </div>
            </div>

            <div style={{ ...rowStyle, height: '16%' }}>
              <div style={columnStyle}>
                SCORE
              </div>

              <div style={cellStyle}>
                {data.anomalyScore}
              </div>
            </div>
          </div>
        </div>

        <div style={{ width: '40%', height: '100%', display: 'flex', flexDirection: 'column', gap: 7, borderRadius: 8 }}>
          <div style={{ ...columnStyle, width: '100%', height: '9%' }}>
            상세 데이터
          </div>

          {Object.entries(data.features).map(([key, value]) => (
            <div style={{ ...rowStyle, height: `calc((100% - 9%) / ${Object.keys(data.features).length})`, gap: 7, fontSize: 16 }}>
              <div style={columnStyle}>
                {dataNames[key]}
              </div>

              <div style={cellStyle}>
                {Number(value).toLocaleString()}
              </div>
            </div>))}
        </div>
      </div>
    </div>
  );
}